import { supportedEvmNetworkKeys } from "@bbb/utils";
export const userStatusValues = [
    "pending",
    "active",
    "suspended",
    "expired",
];
export const userInviteStatusValues = [
    "pending",
    "claimed",
    "expired",
    "active",
];
export const userInviteMethodValues = ["link"];
export const communityStatusValues = ["draft", "active", "suspended"];
export const userTypeValues = [
    "community-user",
    "community-owner",
    "community-admin",
];
export const communityRoleValues = ["admin", "owner"];
export const assignableCommunityRoleValues = ["admin"];
export const envValues = ["development", "test", "production"];
export const badgeTierValues = [
    "Normie",
    "Builder",
    "Architect",
    "OG",
    "Ambassador",
];
export const campaignStatusValues = [
    "draft",
    "scheduled",
    "live",
    "ended",
    "suspended",
];
export const whitelistedImageContentTypeValues = [
    "image/jpeg",
    "image/png",
    "image/webp",
    "image/gif",
];
export const communityPermissionValues = [
    "create_campaign",
    "review_quest_submissions",
    "manage_settings",
];
export const blockchainNetworksValues = supportedEvmNetworkKeys;
export const campaignRewardMethodValues = [
    "leaderboard-raffle-token",
    "completion-nft",
];
export const rewardTypeValues = ["token", "nft"];
export const tokenKeyValues = ["USDC", "USDT"];
export const questSubmissionStatusValues = [
    "submitted",
    "approved",
    "rejected",
];
export const tweetActionValues = ["like", "retweet", "reply"];
export const smartScoringActionValues = ["tweet", "reply"];
export const notificationTypeValues = [
    "quest-deadline",
    "referral-milestone",
    "achievement",
    "reward",
    "feedback",
    "kyc",
    "badge-upgrade",
    "campaign-live",
    "campaign-ended",
    "quest-retry",
    "block-earned",
    "quest-activity",
    "new-quest",
    "leaderboard-created",
];
export const DESCRIPTION_LIMIT = 4096;
export const QUEST_REVIEW_NOTE_LIMIT = 500;
export const questTypeValues = [
    "twitter.common",
    "twitter.follow",
    "twitter.special_ratio",
    "manual.screenshot",
    "manual.url",
    "manual.text",
    "quiz",
    "visit_link",
    "verified_account",
    "smart_scoring",
    // When adding new quest types, keep this list in sync with QuestConfigByType.
];
export const COMMUNITY_SOCIAL_PLATFORMS = ["twitter", "discord"];
export const distributionMethodValues = ["leaderboard-raffle", "completion"];
